import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/boulder")({
  head: () => ({
    meta: [
      // Indexable since 3 Oct 2026, as on the old production site (Wayback
      // 2025 shows "index, follow"). The sitemap lists this page.
      { title: "Schedule Your FREE Hair Transplant Consultation in Boulder, CO" },
      {
        name: "description",
        content:
          "Schedule your free hair restoration consult with RESTORE in Boulder CO. You can do it in-person or virtually. Our client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "Schedule Your FREE Hair Transplant Consultation in Boulder, CO",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Boulder, Colorado.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/boulder/",
      },
    ],
  }),
  component: ScheduleBoulderPage,
});

function ScheduleBoulderPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Boulder
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=49646889" />
        </div>
      </main>
      <Footer />
    </div>
  );
}